import * as React from 'react';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import PersonAdd from '@mui/icons-material/PersonAdd';
import Settings from '@mui/icons-material/Settings';
import Logout from '@mui/icons-material/Logout';
import {useUser} from "../auth/useUser";
import {useState} from "react";
import LoginModal from "./LoginModal";
import {Badge} from "@mui/material";


export default function AccountMenu() {
  const [user, userActions] = useUser();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const [openLogin, setOpenLogin] = useState<boolean>(false);

  const handleOpenLogin = () => {
    setOpenLogin(true);
  };

  const handleCloseLogin = () => {
    setOpenLogin(false);
  };




  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (user.isAuthenticated) {
      setAnchorEl(event.currentTarget);
    }
    else {
      handleOpenLogin();
    }
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = (ev: React.MouseEvent) => {
    ev.preventDefault();
    const href = (ev.currentTarget as HTMLAnchorElement).getAttribute('href');
    // setIsLoading(true);

    userActions.logout().then(() => {
      // setIsLoading(false);
      location.assign(href);
    });
  };

  return (
    <React.Fragment>
      <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
        <Tooltip title="Profil">
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
          >
            <Badge color="success"
                   variant="dot"
                   invisible={!user.isAuthenticated}
                   anchorOrigin={{
                     vertical: 'top',
                     horizontal: 'right',
                   }}
                   overlap="circular" badgeContent=" "
            >
              <Avatar sx={{ width: 32, height: 32 }}></Avatar>
            </Badge>

          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
          <MenuItem onClick={() => {window.location.href = '/user'}}>
            <Avatar /> Profil
          </MenuItem>
          <Divider />
          <MenuItem onClick={() => {window.location.href = '/user/profile'}}>
            <ListItemIcon>
              <Settings fontSize="small" />
            </ListItemIcon>
            Einstellungen
          </MenuItem>
          <MenuItem href='/' onClick={handleLogout}>
            <ListItemIcon>
              <Logout fontSize="small" />
            </ListItemIcon>
            Abmelden
          </MenuItem>
      </Menu>
      <LoginModal  type={'login'} open={openLogin} onClose={handleCloseLogin}></LoginModal>
    </React.Fragment>
  );
}
